import { THIN } from '../../documentos/commercialExcelUtils';
import HT_BORDER_TEMPLATE from './htBorderTemplate.json';

/** Bordes por celda extraídos de Invoice 5019 / hoja HT (solo lados con línea en original). */
export function borderFromEdgeCode(code) {
  if (!code) return {};
  return {
    top: code.includes('t') ? THIN : undefined,
    bottom: code.includes('b') ? THIN : undefined,
    left: code.includes('l') ? THIN : undefined,
    right: code.includes('r') ? THIN : undefined,
  };
}

function blankEdges() {
  return { t: false, b: false, l: false, r: false };
}

function edgesFor(map, r, c) {
  const key = `${r},${c}`;
  let edges = map.get(key);
  if (!edges) {
    edges = blankEdges();
    map.set(key, edges);
  }
  return edges;
}

function addEdgeCode(map, r, c, code) {
  if (!code) return;
  const edges = edgesFor(map, r, c);
  if (code.includes('t')) edges.t = true;
  if (code.includes('b')) edges.b = true;
  if (code.includes('l')) edges.l = true;
  if (code.includes('r')) edges.r = true;
}

function borderFromEdges(edges) {
  const border = {};
  if (edges.t) border.top = THIN;
  if (edges.b) border.bottom = THIN;
  if (edges.l) border.left = THIN;
  if (edges.r) border.right = THIN;
  return border;
}

/**
 * ExcelJS comparte el estilo de la celda maestra con el resto de la unión.
 * Asignar el borde en una celda esclava pisa el de toda la unión.
 * Se juntan solo los lados exteriores y se escriben en la maestra.
 */
function foldMergeOuterEdges(ws, map) {
  const slaves = new Set();
  Object.values(ws._merges || {}).forEach((range) => {
    const master = edgesFor(map, range.top, range.left);
    for (let r = range.top; r <= range.bottom; r += 1) {
      for (let c = range.left; c <= range.right; c += 1) {
        const edges = map.get(`${r},${c}`);
        if (edges) {
          if (r === range.top && edges.t) master.t = true;
          if (r === range.bottom && edges.b) master.b = true;
          if (c === range.left && edges.l) master.l = true;
          if (c === range.right && edges.r) master.r = true;
        }
        if (r !== range.top || c !== range.left) slaves.add(`${r},${c}`);
      }
    }
  });
  return slaves;
}

function applyEdgeMap(ws, map, slaves) {
  map.forEach((edges, key) => {
    if (slaves.has(key)) return;
    if (!edges.t && !edges.b && !edges.l && !edges.r) return;
    const [r, c] = key.split(',').map((n) => Number(n));
    ws.getCell(r, c).border = borderFromEdges(edges);
  });
}

/**
 * Líneas que la plantilla no guarda en la celda.
 * No agrega divisiones internas: lote, pesos, transporte y marcas van sin cuadrícula, como el PDF.
 */
function addExcelOnlyLines(map) {
  addEdgeCode(map, 12, 4, 'b');
}

export function applyHtBordersFromTemplate(ws) {
  const map = new Map();
  Object.entries(HT_BORDER_TEMPLATE).forEach(([key, code]) => {
    const [r, c] = key.split(',').map((n) => Number(n));
    addEdgeCode(map, r, c, code);
  });
  addExcelOnlyLines(map);
  const slaves = foldMergeOuterEdges(ws, map);
  applyEdgeMap(ws, map, slaves);
}

export function htBorderCodeForCell(excelRow, excelCol) {
  return HT_BORDER_TEMPLATE[`${excelRow},${excelCol}`] || '';
}

export function htPdfLineWidthFromCode(code) {
  const w = 0.15;
  return {
    top: code.includes('t') ? w : 0,
    bottom: code.includes('b') ? w : 0,
    left: code.includes('l') ? w : 0,
    right: code.includes('r') ? w : 0,
  };
}
